<template>
  <div class="flowCenter">
    <div class="box">
        <div class="container clear">
            <div class="main-left fl">
                <sidebar-page></sidebar-page>
            </div>
            <div class="main-right fl">
                <div class="mt10 mb10 txt-s16 txt-red txt-center">每种类型流量充值100元起，每次加价100元。</div>
                <div class="menu-model">
                    <div class="rechangeBox_list">
                        <ul class="clear">
                            <li>平台类型</li>
                            <li>流量类型</li>
                            <li>订购金额</li>
                            <li>订购条数</li>
                            <li>单价</li>
                        </ul>
                    </div>
                    <table class="rechangeBoxTable">
                        <tbody>
                            <tr v-for="(item,index) in list" :key="index" v-if="item.platform !== '抖音'">
                                <td><div v-text="item.platform"></div></td>
                                <td><div v-text="item.module"></div></td>
                                <td>
                                    <el-input-number class="rechargeNumber" v-model="num1[index]" :min="minMoney(num1[index], index, item.initQty)" :step="objPrice[index]" @change="changeMoney(num1[index],index)">
                                    </el-input-number>
                                    <span class="numberClear" @click="clear(index)">x</span>
                                    <span class="mr in-block">元</span>
                                </td>
                                <td><div><span>{{strip[index]}}</span>条</div></td>
                                <td><div>{{item.price}}/条</div></td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>金额总计</td>
                                <td><span class="allNumber">{{allNumber}}</span>元</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="rechargeBt">

                        <a @click="goPay()">
                          <el-button type="primary">立即购买</el-button>
                        </a>
                    </div>
                </div>
            </div>
            <el-dialog title="请问是否支付成功?" :visible.sync="dialogVisible" width="30%" >
                <div>
                    <!-- <p>请问是否支付成功?</p> -->
                    <p>如已支付成功可以忽略此提示，支付失败请加本站微信联系客服。</p>
                </div>
                <span slot="footer" class="dialog-footer">

                    <el-button type="primary" @click="payBox()">确 定</el-button>

                </span>
            </el-dialog>
        </div>
    </div>
  </div>
</template>
<script>
import sidebarPage from '../../components/sidebar'
import http from '../../axios'
import { baseUrl } from '@/http/api.js'
export default {
  components: {
    sidebarPage
  },
  data () {
    return {
      allNumber: 0, // 金额总计
      list: [], // 价格信息数据
      num1: [], // 订购数量
      strip: [], // 订购金额
      formInfo: [{
        platformType: 'taobao',
        flowType: '01',
        countRemainder: 1
      }],
      dialogVisible: false,
      objPrice: []

    }
  },
  methods: {
    clear (num) {
      let _this = this
      _this.$set(_this.num1, num, 0)
      _this.countMoney()
      _this.countStrip(num)
    },
    minMoney (money, index, minmoney) { // 最少金额限制
      let _this = this
      if (money === 0 || money === '') {
        return 0
      } else {
        if (money < minmoney) {
          _this.num1[index] = minmoney
          _this.countStrip(index)
        }
        return minmoney
      }
    },
    countMoney () { // 实时金钱总额
      let _this = this
      let sum = 0
      _this.num1.forEach((item) => {
        sum += item
      })
      // 返回
      //   _this.allNumber = Number(sum.toFixed(1))
      _this.allNumber = Number(sum)
    },
    countStrip (index) { // 实时计算每条条数
      let _this = this
      let num = Number(_this.num1[index]) / Number(_this.list[index].price)
      _this.strip[index] = Math.round(Number(num))
      _this.countMoney()
    },
    changeMoney (num, index) { // 改变金额
      let _this = this
      if (num === undefined) {
        _this.$message('条数不能为空')
        _this.$set(_this.num1, index, 0)
        _this.num1[index] = 0
      }
      let money = _this.num1[index]
      if (/\d/.test(money) && money % 100 === 0) {
        // console.log('为100倍数')
      } else {
        // _this.$message({
        //   type: 'warning',
        //   message: '请输入100的倍数'
        // })
        // 条数非100倍数，强制成为100倍数
        _this.num1[index] = parseInt((_this.num1[index] / 100 + 1)) * 100
      }
      _this.countStrip(index)
    },
    //立即购买
    goPay () {
      let _this = this
      if (!localStorage.getItem('info')) {
        _this.$message({
          type: 'warning',
          message: '请登录后使用'
        })
        _this.$router.push({path: '/login'})
        return
      }
      if (_this.allNumber <= 0) {
        _this.$message({
          type: 'warning',
          message: '选中金额必须大于0'
        })
        return
      }
      _this.dialogVisible = true
      let formobj = {}
      _this.formInfo = []
      _this.num1.forEach((item, index) => {
        if (item !== 0 && item !== '') {
          formobj = {}
          formobj.amount = item * 100
          formobj.goodsId = _this.list[index].goodsId
          _this.formInfo.push(formobj)
        }
      })
      let params = _this.formInfo
      localStorage.setItem('payInfo', JSON.stringify(_this.formInfo))
      let routeData = _this.$router.resolve({
        path: '/pay'
      })
      //打开新的空白页面
      window.open(routeData.href, '_blank')
      try {
        http.orderCreate(params).then(({ data }) => {
          switch (data.code) {
            case 0:
              // localStorage.setItem('urlPay', baseUrl + '/api/order/pay?orderId=' + data.data)
              // var tempwindow = window.open()
              // tempwindow.location.href = baseUrl + '/api/order/pay?orderId=' + data.data
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              // localStorage.setItem('urlPay', 'http://www.yinliuchi365.com/#/login')
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 支付完成跳转到个人中心页面
    payBox () {
      let _this = this
      _this.$router.push({path: '/userCenter'})
    },
    // 获取初始列表
    getDataList () {
      if (!localStorage.getItem('token')) {
        this.$message.info('登录后即可使用')
        this.$router.push({path: '/login'})
        return
      }
      let _this = this
      try {
        http.goodsConfigList('').then(({ data }) => {
          switch (data.code) {
            case 0:
              _this.list = data.data
              let obj = {}
              let obj1 = {}
              _this.list.forEach((item, index) => {
                obj = {}
                obj1 = {}
                switch (item.platform) {
                  case 1:
                    item.platform = '淘宝'
                    break
                  case 2:
                    item.platform = '京东'
                    break
                  case 3:
                    item.platform = '拼多多'
                    break
                  case 4:
                    item.platform = '抖音'
                    break
                  default:
                    item.platform = '其他'
                    break
                }
                switch (item.module) {
                  case 1:
                    item.module = 'pc流量'
                    break
                  case 2:
                    item.module = 'app流量'
                    break
                  case 3:
                    item.module = '猜你喜欢'
                    break
                  // case 4:
                  //   item.module = '淘口令'
                  //   break
                  case 5:
                    item.module = '搜索收藏'
                    break
                  case 6:
                    item.module = '搜索加购'
                    break
                  case 7:
                    item.module = '店铺收藏'
                    break
                  case 8:
                    item.module = '旺旺打标'
                    break
//                  case 9:
//                    item.module = '宝贝点赞'
//                    break
                  // case 10:
                  //   item.module = '每日好店'
                  //   break
                  case 11:
                    item.module = '商品收藏'
                    break
                  case 12:
                    item.module = '聚划算'
                    break
                  case 13:
                    item.module = '直接加购'
                    break
                  case 14:
                    item.module = '淘抢购'
                    break
                  // case 15:
                  //   item.module = '达人关注'
                  //   break
                  case 16:
                    item.module = '直播观看'
                    break
                  case 17:
                    item.module = '逛逛点赞'
                    break
                  case 18:
                    item.module = '抖音关注'
                    break
                  case 19:
                    item.module = '抖音点赞'
                    break
                  case 20:
                    item.module = '抖音播放'
                    break
                  default:
                    item.module = '其他'
                    break
                }

                let objPrice = Math.round(item.qtyOfPart * item.price / 100)
                _this.objPrice.push(objPrice)
                obj1 = Math.round(item.initQty / (item.price / 100))
                item.price = (item.price / 100).toFixed(2)
                obj = item.initQty || 0
                _this.num1.push(obj)

                _this.strip.push(obj1)
              })
              _this.countMoney()
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    }
  },
  mounted () {
    this.getDataList()
  }
}
</script>
<style lang="less" scoped>
.container {
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    border-radius:5px;
    width: 1200px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    .main-left {
        width: 15%;
    }
    .main-right {
        width: 80%;
        padding: 15px;
        padding-top: 8px;
        .menu-model {
            .rechangeBox_list ul {
                border: 1px solid #e1e2e4;
                border-radius: 4px;
                li {
                    float: left;
                    text-align: center;
                    width: 20%;
                    color: #666;
                    line-height: 30px;
                    font-size: 15px;
                    display: block;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-right: 1px solid #e1e2e4;
                }
                li:last-child {
                    border-right: 0;
                }
            }
        }
        .allNumber{
            color: #ff1e00;
            font-size: 16px;
        }
        .rechargeBt{
            padding-right: 60px;
            margin-top: 15px;
            text-align: right;
        }
        .rechangeBoxTable{
            text-align: center;
            width: 100%;
            td{
                width: 20%;
                padding: 3px 0;
                color: #666;
                font-size: 14px;
            }
        }
        /deep/ .el-input-number{
            line-height: 28px;
            width: 130px;
        }
        /deep/ .el-input__inner{
            height: 20px;
            line-height: 20px;
            padding-left: 35px;
            padding-right: 45px;
        }
        /deep/.el-input-number__decrease,
        /deep/.el-input-number__increase{
            width: 27px;
            height: 18px;
            line-height: 18px;
            top: 5px;
        }
        .numberClear{
            position: relative;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #fd863a;
            display: inline-block;
            vertical-align: middle;
            color: #fff;
            cursor: pointer;
            text-align: center;
            left: -53px;
            line-height: 9px;
            top: -1px;
            font-size: 12px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/flowCenter/flowCenter.vue